import React from "react";

import { Trans } from "app/utils";

import ButtonLink from "./ButtonLink";
import styles from "./view-all-link.module.scss";

type ViewAllLinkProps = {
  to: string;
};

const ViewAllLink: React.FC<ViewAllLinkProps> = ({ to }) => (
  <ButtonLink to={to} className={styles.link}>
    <Trans>View All</Trans>
  </ButtonLink>
);

export default ViewAllLink;
